export default __webpack_public_path__ + "static/media/bg_131367871.1d34fe99.webp";